import { render } from "./LicenseFormModal.vue?vue&type=template&id=02290772"
import script from "./LicenseFormModal.vue?vue&type=script&lang=js"
export * from "./LicenseFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/mohsen-ampd-agency/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__